<div mat-dialog-title class="dialog-header aum-typo-headline-3">
    <div class="dialog-title">
        <span class="title-span"> {{ 'aumico_notes_referencing_title' | i18next }}</span>
    </div>
    <div class="seprator"></div>
    <div class="close-dialog">
        <mat-icon class="close-dialog-icon" (click)="closeDialog()" svgIcon="interface-delete 1"></mat-icon>
    </div>
</div>
<div mat-dialog-content class="mat-dialog-content">
    <div class="selection-title">
        <span> {{ 'aumico_notes_referencing_sub_title' | i18next }} </span>
    </div>
    <mat-form-field appearance="outline" class="search-input">
        <input
            type="text"
            [placeholder]="'aumico_search_placeholder' | i18next"
            matInput
            [matAutocomplete]="auto"
            [formControl]="filterCtrl"
        />
        <mat-icon matSuffix svgIcon="interface search"></mat-icon>
    </mat-form-field>

    <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        stopPropagation
        (optionSelected)="onOptionClicked($event.option.value)"
    >
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
            <div class="option-grid" stopPropagation (click)="$event.preventDefault(); onOptionClicked(option)">
                <label class="col1">
                    <!-- First Column Content -->
                    <span class="custom-checkbox">
                        <input type="checkbox" [checked]="selectedOptions.has(option.id)" />
                        <span class="checkmark"></span>
                        <span class="col-caption"> {{ option.caption }}</span>
                    </span>
                </label>
                <div class="col2">
                    <!-- Second Column Content with blue background -->
                    {{ option.totalRow.currentValue | finNumber }}
                </div>
                <div class="col3">
                    <!-- Third Column Content -->
                    {{ option.totalRow.previousValue | finNumber }}
                </div>
            </div>
        </mat-option>
    </mat-autocomplete>

    <mat-chip-list class="selected-items">
        <mat-chip *ngFor="let item of currentSelectedItems">{{ item.caption }}</mat-chip>
    </mat-chip-list>
</div>

<div class="actions-footer">
    <mat-dialog-actions>
        <button aum-button (click)="closeDialog()" color="basic">
            {{ 'aumico_annual_report_cancel_button' | i18next }}
        </button>
        <button aum-button (click)="onSaveClicked()" color="primary">
            {{ 'aumico_notes_referencing_add_referencing' | i18next }}
        </button>
    </mat-dialog-actions>
</div>
